import {
  Button,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
import ModalHeader from '../Modal/ModalHeader';

interface CancelCreateNewReasonDialogProps {
  closeCancelDialog: () => void;
  closeCreateNewReasonDialog: () => void;
}

export const CancelCreateNewReasonDialog = ({
  closeCreateNewReasonDialog,
  closeCancelDialog,
}: CancelCreateNewReasonDialogProps) => {
  const closeAllDialogs = () => {
    closeCreateNewReasonDialog();
    closeCancelDialog();
  };

  return (
    <>
      <ModalHeader
        title="Discard progress on creating new Reason?"
        onClose={closeCancelDialog}
      />
      <DialogContent dividers>
        <Typography variant="body2">
          You will lose progress on creating this new Reason, do you wish to
          proceed? You can also minimize the modal to resume Reason creation
          later.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeAllDialogs}>Discard</Button>
        <Button
          color="primary"
          variant="outlined"
          onClick={() => closeCancelDialog()}
        >
          Go Back
        </Button>
      </DialogActions>
    </>
  );
};
